import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
//import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'

import axios from "axios";
import { globalConfig } from "../../../config/config";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";
// const querystring = require("querystring");
const CreateContentCategories = () => {
  const [contentCategoryTypes, setContentCategoryTypes] = useState([]);
//   const { currentContentObject } = useContentObjectContext();
//   const {token,userMetadata}=useAuth()
	const token = globalConfig.hardcoded_header;
//   const history = useHistory();
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentCategoryId: 0,
    contentId: 0, //currentContentObject,
    contentCategoryTypeId: 0,
    contentCategoryName: "",
    contentCategoryDescr: "",
    lastUpdateUser: 0,
    securityContextId: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-categories/`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-categories/contentCategoryId`;
    console.log("Before axios request object = " + JSON.stringify(state));
    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentCategoryId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentCategoryId
          );
          // console.log(this.state.contentCategoryTypeId);
          // && response2.data.contentCategoryId === this.state.contentCategoryId
          // response2.data.contentCategoryId == this.state.contentCategoryId
          //
          if (response2.status === 200) {
            // console.log(response2.data.contentCategoryTypeId);
            // console.log(this.state.contentCategoryTypeId);
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      setState({
        ...state,
        contentCategoryId: 5,
        contentId: 0,
        contentCategoryTypeId: 0,
        contentCategoryName: " ",
        contentCategoryDescr: " ",
        lastUpdateUser: 0,
        lastUpdateDate: new Date(),
      });
    });

    // console.log("SetState Message info-"+this.contentObjectName);
    // console.log("SetState Message info-"+this.contentCategoryName);
    // console.log("SetState Message info-"+this.contentCategoryDescr);
  }
  function handleRest(event) {
    setState({
      ...state,
      contentId: 0,
      contentCategoryTypeId: 0,
      contentCategoryName: " ",
      contentCategoryDescr: " ",
    });
    // this.contentObjectName = "";
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-category-types`,
         apiHeader(token)
      )
      .then((res) => {
        const contentCategoryTypes = res.data;
        console.log(contentCategoryTypes);
        setContentCategoryTypes(contentCategoryTypes);
      })
      .catch((x) => {
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Category</h4>			
			<Link to="/breeze/list-content-categories">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <input type="hidden" id="contentId" value={0} />
        <div className="container-fluid">
          <div className="form-group row">
            <label
              className="ContentTitle col-sm-2"
              value="Content Object Name"
            >
              Content Object Name
            </label>
            <input
              id="contentObjectName"
              readOnly
              className="form-control input-xlarge col-sm-8"
              value={state.contentId}
            />
            {/* <input id="contentObjectName" className="form-control input-xlarge col-sm-8"
				    // value = {state.contentObjectName}
				>
				</input>                        	 */}
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Category Type">
              Category Type
            </label>
            <select
              id="contentCategoryTypeId"
              className="form-control input-xlarge col-sm-8"
              onChange={handleChange}
            >
              <option>Click to make selection</option>
              {contentCategoryTypes.map(
                ({ contentCategoryTypeName, contentCategoryTypeId }) => (
                  <option
                    key={contentCategoryTypeId}
                    value={contentCategoryTypeId}
                  >
                    {contentCategoryTypeName}
                  </option>
                )
              )}
            </select>
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Category Object">
              Category Object
            </label>
            <input
              id="contentCategoryName"
              className="form-control input-xlarge col-sm-8"
              value={state.contentCategoryName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Description">
              Description
            </label>
            <textarea
              id="contentCategoryDescr"
              className="form-control input-xlarge col-sm-8"
              value={state.contentCategoryDescr}
              onChange={handleChange}
            />
          </div>
          <hr />
          <button
            className="btn btn-primary"
            value="Clear"
            type="reset"
            onClick={handleRest}
          >
            {" "}
            Clear
          </button>
          &nbsp;
          <button
            className="btn btn-success"
            value="Create"
            type="reset"
            onClick={handleSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContentCategories;
